import { Component, DestroyRef, OnInit } from '@angular/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterLinkActive
} from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { Breadcrumbs } from '@app/shared/components/breadcrumbs/models/breadcrumbs.model';
import { filter, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { pageWhoNoAccessConstant } from '@app/shared/components/breadcrumbs/constants/page-who-no-access.constant';
import { Select } from '@ngxs/store';
import { ApplicationState } from '@app/_state/app.state';
import { BaseItem } from '@app/shared/models';

@Component({
  selector: 'app-breadcrumbs',
  imports: [RouterLink, TranslatePipe, RouterLinkActive],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss'
})
export class BreadcrumbsComponent implements OnInit {
  @Select(ApplicationState.breadcrumbsInfo)
  breadcrumbsInfo$: Observable<BaseItem[]>;

  public breadcrumbs: Breadcrumbs[] = [];
  public isPageAccessToBreadcrumbs: boolean = true;
  public breadcrumbsInfo: BaseItem[] = [];

  public readonly excludedUrls = ['/procurement/', '/commercial-documents/'];

  private readonly pageWhoNoAccess = pageWhoNoAccessConstant;

  constructor(
    private router: Router,
    private destroyRef: DestroyRef
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map((event: NavigationEnd) => event.url),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.loadBreadcrumbs();
      });
  }

  ngOnInit() {
    this.breadcrumbsInfo$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.breadcrumbsInfo = data;

        this.loadBreadcrumbs();
      });
  }

  public routeToPage(url: string): void {
    if (this.excludedUrls.includes(url)) {
      return;
    }
    this.router.navigate([url]);
  }

  private loadBreadcrumbs() {
    const urlWithoutQuery = this.router.url.split('?')[0];

    if (this.pageWhoNoAccess.includes(urlWithoutQuery)) {
      this.isPageAccessToBreadcrumbs = false;
      return;
    }

    this.isPageAccessToBreadcrumbs = true;

    let urlParts = urlWithoutQuery.split('/').filter(Boolean);

    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    if (urlParts.length >= 2 && uuidRegex.test(urlParts[urlParts.length - 2])) {
      urlParts = urlParts.slice(0, -1);
    }

    let accumulatedPath = '';
    this.breadcrumbs = urlParts.map(part => {
      accumulatedPath += `/${part}`;

      const matched = this.breadcrumbsInfo?.find?.(item => item.id === part);
      const title = matched?.name || part.replace(/-/g, '_').toUpperCase();

      return {
        title: title,
        url: accumulatedPath + '/'
      };
    });
  }
}
